const guiColors = {
    'motion-primary': '#ff9000',
    'motion-primary-transparent': '#FF9000e6',
    'motion-tertiary': '#d37700',

    'looks-secondary': '#ff9000',
    'looks-secondary-light': '#ffb144',
    'looks-secondary-lighter': '#ffc879',
    'looks-transparent': '#ff900059',
    'looks-light-transparent': '#ffb14426',
    'looks-secondary-dark': '#bb6c00',
    'looks-secondary-darker': '#784600',
    'looks-secondary-deep-dark': '#502e00',
	
	'data-primary': '#ff0004',

    'extensions-primary': '##ff0004',
    'extensions-tertiary': '#c10004',
    'extensions-transparent': '##ff000435',
    'extensions-light': '#ff4f52',

    'drop-highlight': '#ff970f',
	
	'menu-bar-background-image': 'linear-gradient(to right, #ff9000 0%, #ff0004 100%)',
    'menu-bar-background-image-dark': 'linear-gradient(to right, #bb6c00 0%, #a00104 100%)'
};


export {
    guiColors,
};